module.exports = __webpack_public_path__ + "img/layer.7e2f1d8b.svg";